module.exports = __webpack_public_path__ + "img/logo-sushiset-svg.318d01b.svg";